// LIBRARIES
import styled from "styled-components";
import Pagination from "@mui/material/Pagination";

// MISC
import { COLORS } from "constants/styleVariables";

export const PaginationContainer = styled.div`
  max-width: 1560px;
  margin-top: 30px;
  display: flex;
`;

export const TablePagination = styled(Pagination)`
  && {
    margin-left: auto;
    margin-right: 0;
    .MuiButtonBase-root {
      color: ${COLORS.rainbowIndigo};

      font-weight: bold;
      position: relative;
      margin-right: 0;
      &:hover {
        background-color: transparent;
        color: ${COLORS.cornflowerBlue};
      }

      .MuiSvgIcon-root {
        color: ${COLORS.cornflowerBlue};
        font-size: 2.5rem;
        &:hover {
          color: ${COLORS.cornflowerBlue};
        }
      }

      &.Mui-selected {
        background-color: transparent;
        color: ${COLORS.cornflowerBlue};
      }
    }

    .MuiPaginationItem-root {
      color: ${COLORS.rainbowIndigo};
      font-size: 19px;
      font-weight: bold;
    }
  }
`;
